import { v4 } from 'uuid';

import { OrderBy } from '@models/OrderBy';

export const isNumeric = (field: string) =>
  field.toLowerCase().includes('rating') ||
  field.toLowerCase().includes('number') ||
  field.toLowerCase().includes('count') ||
  field.toLowerCase().includes('year');

export const getNewEntry = (field: string): OrderBy => ({
  field,
  id: v4(),
  sortOrder: isNumeric(field) ? 'desc' : 'asc',
});
